export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/about-us": [6],
		"/appointments": [7],
		"/demo": [8,[2]],
		"/education": [9],
		"/error": [10],
		"/health-records": [11,[3]],
		"/health-records/access-log": [12,[3]],
		"/health-records/allergies": [13,[3]],
		"/health-records/assessments-treatment-plans": [14,[3]],
		"/health-records/care-team": [15,[3]],
		"/health-records/clinical-notes": [16,[3]],
		"/health-records/clinical-notes/[id]": [17,[3]],
		"/health-records/diagnoses": [18,[3]],
		"/health-records/goals": [19,[3]],
		"/health-records/health-concerns": [20,[3]],
		"/health-records/health-documents": [21,[3]],
		"/health-records/immunizations": [22,[3]],
		"/health-records/medications": [23,[3]],
		"/health-records/patient-info": [24,[3]],
		"/health-records/procedures": [25,[3]],
		"/health-records/share": [26,[3]],
		"/health-records/test-results": [27,[3]],
		"/health-records/test-results/[id]": [28,[3]],
		"/health-records/test-results/[id]/detail/[componentId]": [29,[3]],
		"/health-records/test-results/[id]/history/[index]": [30,[3]],
		"/health-records/vds": [31,[3]],
		"/health-records/vitals": [32,[3]],
		"/home": [33],
		"/ineligible": [34],
		"/library": [35,[4]],
		"/library/cancerdrugs": [36,[4]],
		"/library/cancerdrugs/[key]": [37,[4]],
		"/library/types": [38,[4]],
		"/library/types/[id]": [39,[4]],
		"/library/types/[id]/[key]": [40,[4]],
		"/messages": [41],
		"/messages/compose": [42],
		"/messages/inbox": [43],
		"/messages/sent": [44],
		"/messages/thankyou": [45],
		"/messages/thread/[id]": [46],
		"/nopatientid": [47],
		"/resources": [48],
		"/resources/[id]": [49]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';